import React from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import Button from "components/ui/Button";
import logo from "../assets/images/logo.png";
import { useForgotPasswordMutation } from "apis/auth";

// Replaces the page that was never routed. The response is the same whether or
// not the address belongs to an account — otherwise this becomes a way to find
// out which admin addresses are real without guessing a password.
const ForgotPassword = () => {
  const { mutate: sendReset, isPending, isSuccess } = useForgotPasswordMutation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: { email: "" } });

  const onSubmit = ({ email }) =>
    sendReset({ email: email?.trim().toLowerCase() });

  return (
    <div className="min-h-screen py-8 px-4 flex items-center justify-center">
      <form
        className="border border-mediumgray p-8 rounded-md w-full max-w-md"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="flex justify-center items-center w-full pb-8">
          <img src={logo} alt="Beleef" className="w-[150px] h-auto" />
        </div>

        <h4 className="text-center">Reset your password</h4>

        {isSuccess ? (
          <p className="text-sm text-darkergray text-center mt-4">
            If that account exists, a reset link is on its way. It expires in 30
            minutes.
          </p>
        ) : (
          <>
            <p className="text-sm text-darkergray text-center mt-2 mb-4">
              Enter your admin email and we'll send you a link.
            </p>

            <div className="mb-6">
              <input
                type="email"
                autoFocus
                autoComplete="username"
                placeholder="Email"
                className={`form-input border ${
                  errors.email ? "border-red-500" : "border-mediumgray"
                }`}
                {...register("email", {
                  required: "Email is required",
                  pattern: { value: /^\S+@\S+$/i, message: "Invalid email" },
                })}
              />
              {errors.email && (
                <p className="form-error-message">{errors.email.message}</p>
              )}
            </div>

            <Button
              type="submit"
              className="w-full black-button"
              loading={isPending}
              disabled={isPending}
            >
              Send reset link
            </Button>
          </>
        )}

        <div className="text-center mt-4">
          <Link to="/login" className="text-blue-600 hover:underline text-sm">
            Back to login
          </Link>
        </div>
      </form>
    </div>
  );
};

export default ForgotPassword;
